import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, ViewEncapsulation } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { Article } from 'shared/types';
import { Page, Section, SubSection } from 'shared/location-enums';

@Component({
    selector: 'clinical-studies',
    templateUrl: './clinical-studies.component.html',
    styleUrls: ['./clinical-studies.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ClinicalStudiesComponent {
    private readonly desktopBreakpoint = 992;

    mainKAs: Article[];
    infoKAs: Article[];
    mainArticleMaxLines = 1000;

    constructor(@Inject(DOCUMENT) private document: Document, articleService: ArticleService) {
        this.setMainArticleMaxLines();
        this.mainKAs = articleService.getArticles(Page.about, Section.research, SubSection.clinicalStudy, undefined, undefined, false);

        this.infoKAs = articleService.getArticles(Page.about, Section.research, SubSection.clinicalStudyReferences, undefined, undefined, false);
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.setMainArticleMaxLines();
    }

    private setMainArticleMaxLines() {
        const width = this.document.defaultView?.innerWidth ?? this.desktopBreakpoint;
        this.mainArticleMaxLines = width >= this.desktopBreakpoint ? 1000 : 5;
    }
}
